import React, { useState, useEffect, useRef }       from 'react';
import { Box, IconButton, Skeleton, Typography }    from '@mui/material';
import KeyboardArrowDownIcon                        from '@mui/icons-material/KeyboardArrowDown';
import { parse, isValid } from 'date-fns';


const MessagesList = ({ messages, activeChat, loading, idSAT }) => {  


    const [isAtBottom, setIsAtBottom] = useState(true);
    const messagesEndRef = useRef(null);
    const messagesContainerRef = useRef(null);    

    // useEffect che scorre automaticamente all'ultimo messaggio quando i messaggi cambiano
    useEffect(() => {
        if (isAtBottom) {
            messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [messages, isAtBottom]);

    // Funzione per scrollare fino all'ultimo messaggio
    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        setIsAtBottom(true);
    };

    // Funzione per monitorare la posizione di scorrimento
    const handleScroll = () => {
        if (messagesContainerRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = messagesContainerRef.current;
            const isNearBottom = scrollHeight - scrollTop <= clientHeight + 50;
            setIsAtBottom(isNearBottom);
        }
    };

    // Funzione per formattare la data
    const formatDate = (dateString) => {
        if (!dateString) {
            return 'Data non valida'; 
        }
    
        const isoDate = new Date(dateString);
        if (!isNaN(isoDate.getTime())) {
            return isoDate.toLocaleDateString(undefined, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
    
        const customDate = parse(dateString, 'dd/MM/yyyy HH:mm', new Date());
        if (isValid(customDate)) {
            return customDate.toLocaleDateString(undefined, {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
            });
        }
    
        return 'Data non valida'; 
    };
    

    return (
        <Box sx={{ borderRadius: '0px 20px 20px 0px', height: '100%', display: 'flex', flexDirection: 'column' }}>
            {/* Header */}
            <Box 
                sx={{ 
                    padding: 2, 
                    borderBottom: '1px solid #e0e0e0', 
                    backgroundColor: '#f5f5f5', 
                    height: '48px', 
                    borderRadius: '0px 20px 0px 0px', 
                    position: 'sticky',
                    top: 0, 
                    zIndex: 1,
                }}
            >
                {loading ? (
                    <Skeleton variant="text" width="40%" height={30} />
                ) : (
                    <Typography variant="h6" fontWeight="bold" color='#FDA03D'>
                        {activeChat?.ragioneSociale} #{activeChat?.idReso} 
                    </Typography>
                )}
            </Box>

            {/* Scrolling Messages */}
            <Box 
                ref={messagesContainerRef}
                onScroll={handleScroll}
                sx={{ 
                    flex: 1, 
                    overflowY: 'auto', 
                    '&::-webkit-scrollbar': { 
                        display: 'none'  // Chrome, Safari, Opera
                    },
                    'msOverflowStyle': 'none',  // IE e Edge
                    'scrollbarWidth': 'none'  // Firefox
                }}
            >
                {messages.map((msg, index) => (
                    <Box
                        key={index}
                        sx={{
                            mt: 1,
                            backgroundColor: msg.from === idSAT ? '#25375d' : '#f0f0f0',
                            color: msg.from === idSAT ? '#FFFFFF' : '#000000',
                            padding: 1.5,
                            ml: msg.from === idSAT ? 'auto' : 1.5,
                            mr: msg.from === idSAT ? 1.5 : 'auto',
                            borderRadius: 2,
                            maxWidth: '40%',         
                            width: 'fit-content',
                            wordBreak: 'break-word',     
                            marginBottom: 1,
                            boxShadow: '0 1px 1px rgba(0,0,0,0.1)',
                        }}
                    >
                        <Typography variant="body1" sx={{ wordWrap: 'break-word' }}>
                            {msg.text}
                        </Typography>
                        <Typography variant="caption" sx={{ display: 'block', textAlign: 'right', marginTop: '4px', fontSize: '0.6em' }}>
                            {formatDate(msg.date)}
                        </Typography>
                    </Box>
                ))}
                <div ref={messagesEndRef} />
            </Box>

            {/* Icona per scrollare in fondo */}
            {!isAtBottom && (
                <IconButton
                    onClick={scrollToBottom}
                    sx={{
                        position: 'sticky',
                        bottom: 16,
                        alignSelf: 'flex-end',
                        mr: 2,
                        zIndex: 2,
                        backgroundColor: '#FDA03D',
                        color: '#ffffff',
                        '&:hover': {
                            backgroundColor: '#d08031',
                        },
                    }}
                >
                    <KeyboardArrowDownIcon />
                </IconButton>
            )}
        </Box>
    );
};

export default MessagesList;
